export const airportsApiPaths = {
  list: '/facilityservice/airports',
} as const;

export const getAirportsApiUrl = {
  list: () => airportsApiPaths.list,
};
